var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var QAndAController = {
    /*****************************************************************************************************
        * Is using route "api/qanda/QuestionRequest" and http method "POST" to call the back-end.
    
        * @param {QuestionRequestUploadDto} data
        * @returns {BestPracticePostDownloadDto}
    ******************************************************************************************************/
    Post: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/qanda/QuestionRequest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/qanda/QuestionRequest/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {QuestionRequestUploadDto} data
        * @returns {BestPracticePostDownloadDto}
    ******************************************************************************************************/
    Patch: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/qanda/QuestionRequest/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/qanda/QuestionRequest/reply" and http method "POST" to call the back-end.
    
        * @param {QuestionRequestReply} dto
        * @returns {void}
    ******************************************************************************************************/
    ReplyToRequest: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/qanda/QuestionRequest/reply", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/qanda/QuestionRequest/{postId}/answer" and http method "POST" to call the back-end.
    
        * @param {string} postId
        * @param {RatingReply} reply
        * @returns {void}
    ******************************************************************************************************/
    AnswerComment: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("reply", JSON.stringify(data.reply));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/qanda/QuestionRequest/{postId}/answer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=QAndAController.js.map